// import curveSVG from 'assets/img/curve-to-link.svg';
// import JoinButton from 'components/JoinButton';
import React from 'react';
// import ScrollToButton from 'src/components/ScrollToButton';
// import Page from 'src/layout/Page';
import './education.css';
import LessonsSchedule from 'components/LessonsSchedule';
// import { useTranslation } from 'react-i18next';

const Education: React.FC = (): React.ReactElement => {
	// const [activeIndex, setActiveIndex] = useState(0);

	return (

		<div className={'education-page'}>
			<LessonsSchedule/>
		</div>
	)
};

export default Education;
